import React from 'react';
import Count from '../../Components/Count';
import {ReactComponent as Home1Icon} from '../../../assets/images/companies/home/home1.svg';
import {ReactComponent as Home2Icon} from '../../../assets/images/companies/home/home2.svg';
import {ReactComponent as Home3Icon} from '../../../assets/images/companies/home/home3.svg';
import {ReactComponent as Home4Icon} from '../../../assets/images/companies/home/home4.svg';
import {ReactComponent as Home5Icon} from '../../../assets/images/companies/home/home5.svg';
import {ReactComponent as Home6Icon} from '../../../assets/images/companies/home/home6.svg';
import './CompaniesHome.scss';
import {useSelector} from 'react-redux';
import {NavLink, useParams} from 'react-router-dom';
import {mainPath} from '../../../routes/paths';
import {useTranslation} from 'react-i18next';

const CompaniesHome = () => {
  const {t} = useTranslation();
  const {id} = useParams();
  const {singleCompany} = useSelector((state) => state.company);

  const defaultStatuses = {
    active: 0,
    pause: 0,
    done: 0
    // progress: 0
  };

  const statusCount = singleCompany?.projects?.reduce(
    (acc, item) => {
      const status = item.status;
      acc[status] = (acc[status] || 0) + 1;
      return acc;
    },
    {...defaultStatuses}
  );

  const cards = [
    {
      title: t('CompaniesHome.active'),
      count: statusCount?.active ?? null,
      image: <Home1Icon />,
      link: `${mainPath.projects}/?cId=${id}`
    },
    {
      title: t('CompaniesHome.paused'),
      count: statusCount?.pause ?? null,
      image: <Home2Icon />,
      link: `${mainPath.projects}/?cId=${id}&pS=pause`
    },
    {
      title: t('CompaniesHome.done'),
      count: statusCount?.done ?? null,
      image: <Home3Icon />,
      link: `${mainPath.projects}/?cId=${id}&pS=done`
    },
    {
      title: t('CompaniesHome.waitingApproval'),
      count: singleCompany?.statistic?.documentsWaiting ?? '',
      image: <Home4Icon />,
      link: mainPath.companiesDocuments.replace(':id', id) + '?pS=requested'
    },
    {
      title: t('CompaniesHome.employees'),
        count: singleCompany?.employees?.length,
      image: <Home5Icon />,
      link: mainPath.companiesEmployees.replace(':id', id)
    },
    {
      title: t('CompaniesHome.customers'),
      count: singleCompany?.clients?.filter(client => client?.isActive)?.length || 0,
      image: <Home6Icon />,
      link: mainPath.companiesCustomers.replace(':id', id)
    }
  ];

  return (
    <div className='companies-home'>
      <div className='companies-home__name'>{singleCompany?.name ?? ''}</div>
      <div className='companies-home__list'>
        {cards?.map((card, idx) => {
          return (
            <NavLink to={card.link} key={idx} className='companies-card__item shadow'>
              <div className='companies-card__title'>
                <span>{card.title}</span>
                {card.count && card.count > 0 ? <Count count={card.count} /> : null}
              </div>
              <div className='companies-card__image'>{card.image}</div>
            </NavLink>
          );
        })}
      </div>
    </div>
  );
};

export default CompaniesHome;
